import { closeReconciliationURLs } from 'routes/close/closeURLs';

import { UserAvatar } from 'components/data-display/UserAvatar';

import { useUsersData } from 'hooks/useUsersData';

import { getName } from 'utils/users/config';

import { GenericNotificationItem } from 'layout/inbox-notifications/GenericNotificationItem';

import type { ReconTaskDeletedNotification } from 'types/inbox-notifications/close/ReconciliationNotifications';

export function DeletedNotificationItem({
  item,
}: {
  item: ReconTaskDeletedNotification;
}) {
  const { usersMap } = useUsersData();
  const actorName = getName(item.actor_id, usersMap);
  if (!item.task) {
    return <div>Reconciliation task not found</div>;
  }

  return (
    <GenericNotificationItem
      item={item}
      url={closeReconciliationURLs.taskBase({
        taskId: item.task.core_snapshot.short_code,
      })}
      avatar={<UserAvatar userId={item.actor_id} />}
      title={`${actorName} deleted a reconciliation.`}
      description={<span>&quot;{item.task.core_snapshot.name}&quot;</span>}
    />
  );
}
